let firebaseConfig: {
  apiKey?: string
  authDomain?: string
  projectId?: string
  storageBucket?: string
  messagingSenderId?: string
  appId?: string
  measurementId?: string
} = {}
switch (import.meta.env.VITE_DEPLOY_ENV) {
  case 'stage':
    firebaseConfig = {
      apiKey: 'AIzaSyCSHZi3A84hgBOX6Qr9nsk5LtUx6zdcEhc',
      authDomain: 'wepin-stage.firebaseapp.com',
      projectId: 'wepin-stage',
      storageBucket: 'wepin-stage.appspot.com',
      messagingSenderId: '852302363833',
      appId: '1:852302363833:web:0282ae893e7fd4edd5af68',
      measurementId: 'G-FCHRF18ZTE',
    }
    break
  case 'production':
    firebaseConfig = {
      apiKey: 'AIzaSyDGKbvXgyBNB-O9O3-PoLNF_lXDiLQNmm4',
      authDomain: 'wepin-prod.firebaseapp.com',
      projectId: 'wepin-prod',
      storageBucket: 'wepin-prod.appspot.com',
      messagingSenderId: '953743945029',
      appId: '1:953743945029:web:9bd25142d64f414154a22c',
      measurementId: 'G-6R0RLZVNMS',
    }
    break
  default:
    firebaseConfig = {
      apiKey: 'AIzaSyDw95B6LAfT5LhjL-VMAevkeR_X-wSmtnw',
      authDomain: 'wepin-dev.firebaseapp.com',
      projectId: 'wepin-dev',
      storageBucket: 'wepin-dev.appspot.com',
      messagingSenderId: '1059640642042',
      appId: '1:1059640642042:web:0e2106d3ff8d1792197c43',
      measurementId: 'G-QXWXHCJJC6',
    }
}

export default firebaseConfig
